export default __webpack_public_path__ + "9b194cfca27441df481468a9dfe71d4d.png";